import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { MenuBannerTranslationFragment } from "@saleor/fragments/types/MenuBannerTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsMenuBannerPageProps
  extends TranslationsEntitiesPageProps {
  menuBanner: MenuBannerTranslationFragment;
}

export const fieldNames = {
  title: "title",
  subtitle: "subtitle",
  url: "url",
  pcImageUrl: "pcImageUrl",
  h5ImageUrl: "h5ImageUrl"
};

const TranslationsMenuBannerPage: React.FC<TranslationsMenuBannerPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  menuBanner,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Menu Banner "{menuBannerName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            menuBannerName: maybe(() => menuBanner.title, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Banner Title"
            }),
            name: fieldNames.title,
            translation: maybe(() =>
              menuBanner.translation ? menuBanner.translation.title : null
            ),
            type: "short" as "short",
            value: maybe(() => menuBanner.title)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Banner Url",
              description: "menuBanner content"
            }),
            name: fieldNames.url,
            translation: maybe(() =>
              menuBanner.translation ? menuBanner.translation.url : null
            ),
            type: "short" as "short",
            value: maybe(() => menuBanner.url)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Banner Subtitle",
              description: "menuBanner content"
            }),
            name: fieldNames.subtitle,
            translation: maybe(() =>
              menuBanner.translation ? menuBanner.translation.subtitle : null
            ),
            type: "short" as "short",
            value: maybe(() => menuBanner.subtitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Banner H5 ImageUrl",
              description: "menuBanner content"
            }),
            name: fieldNames.h5ImageUrl,
            translation: maybe(() =>
              menuBanner.translation ? menuBanner.translation.h5ImageUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => menuBanner.h5ImageUrl)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Banner PC ImageUrl",
              description: "menuBanner content"
            }),
            name: fieldNames.pcImageUrl,
            translation: maybe(() =>
              menuBanner.translation ? menuBanner.translation.pcImageUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => menuBanner.pcImageUrl)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsMenuBannerPage.displayName = "TranslationsMenuBannerPage";
export default TranslationsMenuBannerPage;
